<!--Active Data Pass Section-->
<ng-container *ngIf="usageBucketModel">
  <div class="row m-t-xl m-b-sm" *ngIf="activeDataPasses && activeDataPasses.length > 0">
    <div class="col-8">
      <p class="bold">{{ contentData?.activeDataPassHeader }}</p>
    </div>
    <div *ngFor="let activeDataPass of activeDataPasses">
      <div class="col-12">
        <p class="m-t-md small">
          {{ contentData?.activeDataPassInfoOne }} {{ activeDataPass?.expirationDate }}.
          {{ contentData?.activeDataPassInfoTwo }}
        </p>
      </div>
      <div class="col-12 col-md-8 m-t-md">
        <div class="row">
          <div class="col-6">
            <h6 class="inline-block m-r-xs">
              {{ activeDataPass?.usedTotal }}
              <span *ngIf="activeDataPass?.usedTotal !== unlimitedData">{{
                activeDataPass?.uomUsed
              }}</span>
            </h6>
            <p class="small inline-block">
              <span *ngIf="activeDataPass?.includedTotal"
                >{{ symbolConstants.SLASH }}
                <ng-container
                  *ngIf="
                    activeDataPass?.includedTotal &&
                      activeDataPass?.includedTotal !== unlimitedData;
                    else unlimitedContent
                  "
                >
                  {{ activeDataPass?.includedTotal }}
                  <span
                    *ngIf="
                      activeDataPass?.includedTotal &&
                      activeDataPass?.includedTotal !== unlimitedData
                    "
                    >{{ activeDataPass?.uomIncluded }}</span
                  >
                </ng-container>
                <ng-template #unlimitedContent>4GB</ng-template></span
              >
            </p>
          </div>
          <div class="col-6 text-end">
            <p class="small inline-block p-t-lg">{{ contentData?.highSpeedDataText }}</p>
          </div>
        </div>
        <p-progressBar
          *ngIf="activeDataPass?.usedTotal !== unlimitedData"
          [value]="activeDataPass?.usedPercentage"
          [showValue]="false"
        >
        </p-progressBar>
        <p class="legal m-t-xs">
          {{ activeDataPass?.daysUntilExpiration }} {{ contentData?.daysRemainingText }}
        </p>
      </div>
    </div>
  </div>

  <!--Annual Usage section-->
  <div class="row m-t-xl m-b-sm" *ngIf="annualDataPass">
    <div class="col-8">
      <p class="bold">{{ contentData?.p10mUsageHeader }}</p>
    </div>
    <div class="col-12 col-md-8 m-t-md">
      <div class="row">
        <div class="col-6">
          <h6 class="inline-block m-r-xs">
            {{ annualDataPass?.usedTotal }}
            <span *ngIf="annualDataPass?.usedTotal !== unlimitedData">{{
              annualDataPass?.uomUsed
            }}</span>
          </h6>
          <p class="small inline-block">
            <span *ngIf="annualDataPass?.includedTotal"
              >{{ symbolConstants.SLASH }} {{ annualDataPass?.includedTotal }}</span
            >
            <span
              *ngIf="annualDataPass?.includedTotal && annualDataPass?.usedTotal !== unlimitedData"
              >{{ annualDataPass?.uomIncluded }}</span
            >
          </p>
        </div>
        <div class="col-6 text-end">
          <p class="small inline-block p-t-lg">{{ contentData?.highSpeedDataText }}</p>
        </div>
      </div>
      <p-progressBar
        *ngIf="annualDataPass?.usedTotal !== unlimitedData"
        [value]="annualDataPass?.usedPercentage"
        [showValue]="false"
      >
      </p-progressBar>
      <p class="legal m-t-xs">
        {{ contentData?.dataCycleText }}&nbsp;{{ startDate }} {{ symbolConstants.HYPHEN }}
        {{ endDate }}
      </p>
    </div>
    <div class="col-12 m-t-lg">
      <p class="bold small">{{ contentData?.monthlyDataHeader }}</p>
      <p class="m-t-lg small">
        <span class="bold">{{ contentData?.recommendedMonthlyUsage }} &nbsp;</span
        ><span>{{ contentData?.monthlyDataDescriptionOne }}</span>
      </p>
      <p class="m-t-lg small">{{ contentData?.monthlyDataDescriptionTwo }}</p>
    </div>
  </div>
</ng-container>
<tmo-spinner [setDelay]="hideSpinner"></tmo-spinner>
